import { Card, Divider, Space } from 'antd';
import { useEffect, useState } from 'react';

export function SpCard(props) {
  const { children, footer = [], ...cardProps } = props;

  if (footer && footer.length > 0) {
    return <SpCardFooter {...props}>{children}</SpCardFooter>;
  }

  return (
    <Card {...cardProps} style={{ ...cardProps.style, marginBottom: 0, backgroundColor: '#483E41' }}>
      {children}
    </Card>
  );
}

function SpCardFooter(props) {
  const { children, padding = 24, footer = [], footerStyle, bodyStyle, stickyFooter = false, ...cardProps } = props;
  const [contentHeight, setContentHeight] = useState(400);

  useEffect(() => {
    const selector = document.getElementById('sp-card-content');
    const selectorOffsetTop = selector?.offsetTop;
    const selectorParent = selector?.offsetParent?.scrollHeight;
    const htmlHeight = document.getElementsByTagName('html')[0]?.scrollHeight;
    const headerHeight = document.getElementsByTagName('header')[0]?.scrollHeight;
    const mainHeight = document.getElementsByTagName('main')[0]?.scrollHeight;
    const gapSize = mainHeight - selectorParent;

    const coverHeight = htmlHeight - headerHeight * 2 - selectorOffsetTop - gapSize;

    setContentHeight(htmlHeight <= 1200 ? 1000 : coverHeight);
  }, []);

  return (
    <Card {...cardProps} bodyStyle={{ padding: 0, ...bodyStyle }}>
      <div
        id="sp-card-content"
        style={
          stickyFooter
            ? { position: 'relative', padding, height: contentHeight, overflowY: 'scroll' }
            : { position: 'relative', padding }
        }
      >
        {children}
      </div>
      <Divider style={{ borderColor: '#000' }} />
      <Space style={{ padding: 24, paddingBottom: 18, paddingTop: 10, justifyContent: 'flex-end', ...footerStyle }}>
        {footer.map((ss) => ss)}
      </Space>
    </Card>
  );
}
